module.exports = __webpack_public_path__ + "img/img-8.2d21439e.png";